import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private _selector: string = 'preloader';
  private _element: any;

  constructor() {
  }

  public show(): void {
    this._element = document.getElementById(this._selector);
    if (this._element) {
      this._element.style['display'] = 'block';
    }
  }

  public hide(delay: number = 0): void {
    setTimeout(() => {
      this._element = document.getElementById(this._selector);
      if (this._element) {
        this._element.style['display'] = 'none';
      }
    }, delay);
  }
}
